import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(str: string, maxLength: number = 15, ...args: unknown[]): unknown {
    return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
  }
}
